<template>
  <!-- Introduction -->
    <div class="text-center pt-5 fluid" id="intro">
      <h3> YOU DON'T NEED ANY MORE "GYAAN". YOU HAVE HAD ENOUGH OF IT. </h3>
      <h4>Yet, all that 20-30 years of knowledge &amp; experience hasn't translated <br> into the results you want. Deep down, you know you are capable of so much more.</h4>
      <h4 class="font-weight">We know exactly what is missing!</h4>
      <cq-headings> IMPLEMENTATION </cq-headings>
      <div id="introduction" class="pt-5">
        <b-container class="bv-example-row">
          <b-row>
            <b-col sm="12" md="3" lg="3" id="stop">
              <b-img :src="images.stop" id="stop-img" fluid alt="Stop Image"></b-img>
              <h5 class="intro-para"> being a passive spectator<br> who waits for life to happen. </h5>
            </b-col>
            <b-col>
              <img src="../../assets/image/home/player.png" class="img-fluid" alt="Player Image">
            </b-col>
            <b-col sm="12" md="3" lg="3" id="start">
              <b-img :src="images.start" id="start-img" fluid alt="Start Image"></b-img>
              <h5> being the player who makes<br> life happen on your terms. </h5>
            </b-col>
          </b-row>
        </b-container>        
      </div>
    </div>
    <!-- End Introduction -->

</template>

<script>
import CQHeadings from '../../components/ui/CQHeadings.vue'
// import CQPara from '../../components/ui/CQPara.vue'

// Import Images
import stop from '../../assets/image/home/stop.png'
import start from '../../assets/image/home/start.png'

export default {
    components: {
        'cq-headings' : CQHeadings,
        // 'cq-paratext' : CQPara
    },
    data() {
        return {
            images: { 
                stop,
                start
            }
        }
    }
}
</script>

<style scoped>
#intro >>> #introduction{
  background-image: linear-gradient(rgba(255,255,255,.9), rgba(255,255,255,.9)), url(../../assets/image/home/stadium1.png);
  background-repeat: no-repeat;
  max-width: 100% !important;
  background-size: cover;
}

#intro >>> #stop, #start{
  padding: 100px 0 !important;
}

.font-weight{
  font-size: 29px;
}

#intro >>> #stop img, #start img{
  max-width: 65% !important;
  padding-bottom: 8%;
}

h5 {
  font-size: 22px;
  opacity: .9;
}

/* Mobile View */
@media only screen and (max-width: 992px){

  #intro >>> #stop img, #start img{
    width: 100px !important;
  }

  #intro >>> #stop{
    padding: 10px 0 !important;
  }

  #intro >>> #start{
    padding: 35px 0 !important;
  } 

  #intro >>> .intro-para{
    font-size: 22px !important;
    opacity: .75;
  }
}

@media only screen and (min-width: 992px){
  #intro{
    padding-bottom: 48px;
  }
}
</style>